import { useQuery, useMutation } from '@tanstack/react-query'
import { SavedView } from '../../shared/types'
import { del, get, post, put } from '../fetch'

export function useSavedViewListAll(object: string) {
	return useQuery({
		queryKey: ['api/saved-views', object],
		queryFn: () => get<SavedView[]>(`/api/0/saved-views/${object}`),
	})
}

export function useSavedViewCreate(object: string) {
	return useMutation({
		mutationFn: (data: Pick<SavedView, 'name' | 'filter'>) =>
			put<SavedView>(`/api/0/saved-views/${object}`, data),
		meta: {
			invalidateQueries: [['api/saved-views', object]],
			notifications: {
				success: () => 'Pohled vytvořen',
			},
		},
	})
}

export function useSavedViewUpdate(object: string, id?: string) {
	return useMutation({
		mutationFn: (data: Pick<SavedView, 'name' | 'filter'>) => {
			if (!id) throw new Error('Missing id')
			return post<SavedView>(`/api/0/saved-views/${object}/${id}`, data)
		},
		meta: {
			invalidateQueries: [['api/saved-views', object]],
			notifications: {
				success: () => 'Změny uloženy',
			},
		},
	})
}

export function useSavedViewRemove(object: string) {
	return useMutation({
		mutationFn: (id: string) => del(`/api/0/saved-views/${object}/${id}`),
		meta: {
			invalidateQueries: [['api/saved-views', object]],
			notifications: {
				success: () => 'Pohled smazán',
			},
		},
	})
}
